import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  CircularProgress,
  Grid,
} from "@mui/material";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { activateSearch, deactivateSearch } from '../../../ReduxStore/Slices/search/searchSlice';
import actions from "../../../ReduxStore/actions";

const primaryFilters = [
  { value: "users", label: "Users" },
  { value: "feed", label: "Feed" },
  // { value: "job", label: "Job" },
  // { value: "internship", label: "Internship" },
];

const filterOptions = {
  users: [
    {
      key: "Year_of_completion",
      label: "Year of Completion",
      type: "dropdown",
      values: ["2020", "2021", "2022", "2023", "2024"],
    },
    {
      key: "batch",
      label: "Batch",
      type: "dropdown",
      values: ["B2020", "B2021", "B2022", "B2023"],
    },
    {
      key: "campus",
      label: "Campus",
      type: "dropdown",
      values: ["Chennai", "Bangalore", "Hyderabad"],
    },
    {
      key: "course",
      label: "Course",
      type: "dropdown",
      values: ["Computer Science", "Mechanical", "Electrical"],
    },
  ],
  job: [
    {
      key: "job_type",
      label: "Job Type",
      type: "dropdown",
      values: ["Full Time", "Part Time", "Contract"],
    },
    {
      key: "location",
      label: "Location",
      type: "dropdown",
      values: ["Chennai", "Bangalore", "Remote"],
    },
    {
      key: "skills",
      label: "Skills",
      type: "dropdown",
      values: ["React", "Node", "Python", "Java"],
    },
    {
      key: "full_or_part_time",
      label: "Full or Part Time",
      type: "dropdown",
      values: ["Full Time", "Part Time"],
    },
    {
      key: "posted_date",
      label: "Posted Date",
      type: "date",
    },
  ],
  internship: [
    {
      key: "offered_to",
      label: "Offered To",
      type: "dropdown",
      values: ["React JS", "Python", "Data Science"],
    },
    {
      key: "internship_location",
      label: "Internship Location",
      type: "dropdown",
      values: ["Chennai", "Remote", "Hyderabad"],
    },
    {
      key: "starting_date",
      label: "Starting Date",
      type: "date",
    },
  ],
};

export default function GlobalSearch() {
  const [primaryFilter, setPrimaryFilter] = useState("");
  const [keyword, setKeyword] = useState("");
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");

  const sessionUserId = sessionStorage.getItem("userId")
  console.log(sessionUserId, "sessionUserId")

  // inside component
const dispatch = useDispatch();

  useEffect(() => {
    setFilters({});
    setResults([]);
    setError("");
  }, [primaryFilter]);

  const handleClear = () => {
    // inside handleClear
dispatch(deactivateSearch());
    setPrimaryFilter("");
    setKeyword("");
    setFilters({});
    setResults([]);
    setError("");

  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    if (!primaryFilter) {
      setError("Please select a primary filter.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const payload = {
        primary_filter: primaryFilter,
        keyword,
        filters,
      };


      const data1 = {
              data: {
        primary_filter: primaryFilter,
        keyword,
        filters,
      },
              method: "post",
              apiName: `globalSearch/${sessionUserId}}`,
            };
            const response = await dispatch(actions.GLOBALSEARCH(data1));
    
            console.log(response, "responseresponse")
            dispatch(activateSearch());


      if (response) {
        
        setResults(response);

        // inside handleSubmit

      } else {
        setResults([]);
      }
    } catch (err) {
      setError( "Error fetching results.");
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const renderFilterInputs = () => {
    if (!primaryFilter || !filterOptions[primaryFilter]) return null;


    return (
      <Grid container spacing={2}>
        {filterOptions[primaryFilter].map(({ key, label, type, values }) => (
          <Grid item xs={12} sm={6} md={4} key={key}>
            {type === "dropdown" ? (
              <FormControl fullWidth size="small" sx={{
                minWidth: 140
              }}>
                <InputLabel>{label}</InputLabel>
                <Select
                  value={filters[key] || ""}
                  label={label}
                  onChange={(e) => handleFilterChange(key, e.target.value)}
                >
                  {values.map((val) => (
                    <MenuItem key={val} value={val}>
                      {val}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TextField
                fullWidth
                type={type}
                label={label}
                size="small"
                value={filters[key] || ""}
                onChange={(e) => handleFilterChange(key, e.target.value)}
                InputLabelProps={type === "date" ? { shrink: true } : {}}
              />
            )}
          </Grid>
        ))}
      </Grid>
    );
  };
// sx={{ maxHeight: 200, overflowY: 'auto' }}>
  return (
    <Box maxWidth={1000} mx="auto" mt={4} p={2} sx={{maxHeight:200,overflowY:"auto"}}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small" sx={{minWidth: 140}}>
              <InputLabel id="primary-filter-label">Primary Filter</InputLabel>
              <Select
                labelId="primary-filter-label"
                value={primaryFilter}
                label="Primary Filter"
                onChange={(e) => setPrimaryFilter(e.target.value)}
                required
              >
                {primaryFilters.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent={{ xs: "flex-start", md: "flex-end" }}
            alignItems="center"
          >
            <Button
              type="submit"
              variant="contained"
              size="small"
              disabled={loading || !primaryFilter}
              sx={{ mr: 2,backgroundColor:"var(--main-color)",textTransform:"none"}}
            >
              Search
            </Button>
            <Button onClick={handleClear} 
              sx={{ mr: 2,backgroundColor:"lightgray",textTransform:"none",color:"black"}}
            size="small"
            >
              Clear
            </Button>
            {loading && <CircularProgress size={24} sx={{ ml: 2 }} />}
          </Grid>

          <Grid item xs={12}>
            {renderFilterInputs()}
          </Grid>

          {error && (
            <Grid item xs={12}>
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </Box>
  );
}


// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   MenuItem,
//   Select,
//   TextField,
//   Typography,
//   FormControl,
//   InputLabel,
//   CircularProgress,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Grid,
// } from "@mui/material";
// import axios from "axios";

// const primaryFilters = [
//   { value: "users", label: "Users" },
//   { value: "feed", label: "Feed" },
//   { value: "job", label: "Job" },
//   { value: "internship", label: "Internship" },
//   // { value: "event", label: "Event" },
//   // { value: "mentor_requirement", label: "Mentor Requirement" },
//   // { value: "newsletter", label: "Newsletter" },
// ];

// const filterOptions = {
//   users: [
//     {
//       key: "Year_of_completion",
//       label: "Year of Completion",
//       type: "dropdown",
//       values: ["2020", "2021", "2022", "2023", "2024"],
//     },
//     {
//       key: "batch",
//       label: "Batch",
//       type: "dropdown",
//       values: ["B2020", "B2021", "B2022", "B2023"],
//     },
//     {
//       key: "campus",
//       label: "Campus",
//       type: "dropdown",
//       values: ["Chennai", "Bangalore", "Hyderabad"],
//     },
//     {
//       key: "course",
//       label: "Course",
//       type: "dropdown",
//       values: ["Computer Science", "Mechanical", "Electrical"],
//     },
//   ],
//   job: [
//     {
//       key: "job_type",
//       label: "Job Type",
//       type: "dropdown",
//       values: ["Full Time", "Part Time", "Contract"],
//     },
//     {
//       key: "location",
//       label: "Location",
//       type: "dropdown",
//       values: ["Chennai", "Bangalore", "Remote"],
//     },
//     {
//       key: "skills",
//       label: "Skills",
//       type: "dropdown",
//       values: ["React", "Node", "Python", "Java"],
//     },
//     {
//       key: "full_or_part_time",
//       label: "Full or Part Time",
//       type: "dropdown",
//       values: ["Full Time", "Part Time"],
//     },
//     {
//       key: "posted_date",
//       label: "Posted Date",
//       type: "date",
//     },
//   ],
//   internship: [
//     {
//       key: "offered_to",
//       label: "Offered To",
//       type: "dropdown",
//       values: ["React JS", "Python", "Data Science"],
//     },
//     {
//       key: "internship_location",
//       label: "Internship Location",
//       type: "dropdown",
//       values: ["Chennai", "Remote", "Hyderabad"],
//     },
//     {
//       key: "starting_date",
//       label: "Starting Date",
//       type: "date",
//     },
//   ],
//   event: [
//     {
//       key: "from_date",
//       label: "From Date",
//       type: "date",
//     },
//   ],
//   mentor_requirement: [
//     {
//       key: "mentor_type",
//       label: "Mentor Type",
//       type: "dropdown",
//       values: ["Jury member", "Panelist", "Project Reviewer"],
//     },
//     {
//       key: "from_date",
//       label: "From Date",
//       type: "date",
//     },
//   ],
// };



// export default function GlobalSearch() {
//   const [primaryFilter, setPrimaryFilter] = useState("");
//   const [keyword, setKeyword] = useState("");
//   const [filters, setFilters] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [results, setResults] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     setFilters({});
//     setResults([]);
//     setError("");
//   }, [primaryFilter]);

//   const handleClear = () => {
//     setPrimaryFilter("");
//     setKeyword("");
//     setFilters({});
//     setResults([]);
//     setError("");
//   };


//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!primaryFilter) {
//       setError("Please select a primary filter.");
//       return;
//     }
//     setError("");
//     setLoading(true);
//     try {
//       const payload = {
//         primary_filter: primaryFilter,
//         keyword,
//         filters,
//       };
//       const { data } = await axios.post("http://localhost:5000/api/v1/globalSearch/1", payload);
//       if (data && data.data && data.data.results) {
//         setResults(data.data.results);
//       } else {
//         setResults([]);
//       }
//     } catch (err) {
//       setError(err.response?.data?.Message || "Error fetching results.");
//       setResults([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderFilterInputs = () => {
//     if (!primaryFilter || !filterOptions[primaryFilter]) return null;

//     return (
//       <Grid container spacing={2}>
//         {filterOptions[primaryFilter].map(({ key, label, type }) => (
//           <Grid item xs={12} sm={6} md={4} key={key}>
//             <TextField
//               fullWidth
//               type={type}
//               label={label}
//               size="small"
//               value={filters[key] || ""}
//               onChange={(e) => handleFilterChange(key, e.target.value)}
//               InputLabelProps={type === "date" ? { shrink: true } : {}}
//             />
//           </Grid>
//         ))}
//       </Grid>
//     );
//   };

//   return (
//     <Box maxWidth={1000} mx="auto" mt={4} p={2}>
//       {/* <Typography variant="h5" mb={2}>
//         Global Search
//       </Typography> */}

//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={16} md={4}>
//             <FormControl fullWidth size="small" sx={{ minWidth: 120 }}>
//               <InputLabel id="primary-filter-label">Primary Filter</InputLabel>
//               <Select
//                 labelId="primary-filter-label"
//                 value={primaryFilter}
//                 label="Primary Filter"
//                 onChange={(e) => setPrimaryFilter(e.target.value)}
//                 required
//                 size="small"
                
//               >
//                 {primaryFilters.map(({ value, label }) => (
//                   <MenuItem key={value} value={value}>
//                     {label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={12} sm={6} md={4}>
//             <TextField
//               label="Keyword"
//               value={keyword}
//               onChange={(e) => setKeyword(e.target.value)}
//               fullWidth
//               size="small"
//             />
//           </Grid>
//           <Grid item xs={12} display="flex" justifyContent="flex-end" alignItems="center">
//             <Button type="submit" variant="contained" size="small" disabled={loading || !primaryFilter} sx={{mr:2}}>
//               Search
//             </Button>
//             <Button onClick={handleClear} variant="outlined" color="secondary" size="small">
//               Clear
//             </Button>
//             {loading && <CircularProgress size={24} sx={{ ml: 2 }} />}
//           </Grid>

//           <Grid item xs={12}>
//             {renderFilterInputs()}
//           </Grid>

//           {error && (
//             <Grid item xs={12}>
//               <Typography color="error" variant="body2">
//                 {error}
//               </Typography>
//             </Grid>
//           )}

          
//         </Grid>
//       </form>

//         </Box>
//   );
// }


// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   MenuItem,
//   Select,
//   TextField,
//   Typography,
//   FormControl,
//   InputLabel,
//   CircularProgress,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
// } from "@mui/material";
// import axios from "axios";

// const primaryFilters = [
//   { value: "users", label: "Users" },
//   { value: "feed", label: "Feed" },
//   { value: "job", label: "Job" },
//   { value: "internship", label: "Internship" },
//   { value: "event", label: "Event" },
//   { value: "mentor_requirement", label: "Mentor Requirement" },
//   { value: "newsletter", label: "Newsletter" },
// ];

// const filterOptions = {
//   users: [
//     {
//       key: "Year_of_completion",
//       label: "Year of Completion",
//       type: "dropdown",
//       values: ["2020", "2021", "2022", "2023", "2024"],
//     },
//     {
//       key: "batch",
//       label: "Batch",
//       type: "dropdown",
//       values: ["B2020", "B2021", "B2022", "B2023"],
//     },
//     {
//       key: "campus",
//       label: "Campus",
//       type: "dropdown",
//       values: ["Chennai", "Bangalore", "Hyderabad"],
//     },
//     {
//       key: "course",
//       label: "Course",
//       type: "dropdown",
//       values: ["Computer Science", "Mechanical", "Electrical"],
//     },
//   ],
//   job: [
//     {
//       key: "job_type",
//       label: "Job Type",
//       type: "dropdown",
//       values: ["Full Time", "Part Time", "Contract"],
//     },
//     {
//       key: "location",
//       label: "Location",
//       type: "dropdown",
//       values: ["Chennai", "Bangalore", "Remote"],
//     },
//     {
//       key: "skills",
//       label: "Skills",
//       type: "dropdown",
//       values: ["React", "Node", "Python", "Java"],
//     },
//     {
//       key: "full_or_part_time",
//       label: "Full or Part Time",
//       type: "dropdown",
//       values: ["Full Time", "Part Time"],
//     },
//     {
//       key: "posted_date",
//       label: "Posted Date",
//       type: "date",
//     },
//   ],
//   internship: [
//     {
//       key: "offered_to",
//       label: "Offered To",
//       type: "dropdown",
//       values: ["React JS", "Python", "Data Science"],
//     },
//     {
//       key: "internship_location",
//       label: "Internship Location",
//       type: "dropdown",
//       values: ["Chennai", "Remote", "Hyderabad"],
//     },
//     {
//       key: "starting_date",
//       label: "Starting Date",
//       type: "date",
//     },
//   ],
//   event: [
//     {
//       key: "from_date",
//       label: "From Date",
//       type: "date",
//     },
//   ],
//   mentor_requirement: [
//     {
//       key: "mentor_type",
//       label: "Mentor Type",
//       type: "dropdown",
//       values: ["Jury member", "Panelist", "Project Reviewer"],
//     },
//     {
//       key: "from_date",
//       label: "From Date",
//       type: "date",
//     },
//   ],
// };

// export default function GlobalSearch() {
//   const [primaryFilter, setPrimaryFilter] = useState("");
//   const [keyword, setKeyword] = useState("");
//   const [filters, setFilters] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [results, setResults] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     setFilters({});
//     setResults([]);
//     setError("");
//   }, [primaryFilter]);

//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!primaryFilter) {
//       setError("Please select a primary filter.");
//       return;
//     }
//     setError("");
//     setLoading(true);
//     try {
//       const payload = {
//         primary_filter: primaryFilter,
//         keyword,
//         filters,
//       };
//       const { data } = await axios.post("http://localhost:5000/api/v1/globalSearch", payload);
//       if (data && data.data && data.data.results) {
//         setResults(data.data.results);
//       } else {
//         setResults([]);
//       }
//     } catch (err) {
//       setError(err.response?.data?.Message || "Error fetching results.");
//       setResults([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderFilterInputs = () => {
//     if (!primaryFilter || !filterOptions[primaryFilter]) return null;

//     return filterOptions[primaryFilter].map(({ key, label, type, values }) => {
//       if (type === "dropdown") {
//         return (
//           <FormControl key={key} fullWidth margin="normal">
//             <InputLabel>{label}</InputLabel>
//             <Select
//               value={filters[key] || ""}
//               onChange={(e) => handleFilterChange(key, e.target.value)}
//               label={label}
//             >
//               {values.map((val) => (
//                 <MenuItem key={val} value={val}>
//                   {val}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         );
//       }

//       return (
//         <TextField
//           key={key}
//           label={label}
//           type={type}
//           value={filters[key] || ""}
//           onChange={(e) => handleFilterChange(key, e.target.value)}
//           fullWidth
//           margin="normal"
//           InputLabelProps={type === "date" ? { shrink: true } : {}}
//         />
//       );
//     });
//   };

//   return (
//     <Box maxWidth={600} mx="auto" mt={4} p={2}>
//       <form onSubmit={handleSubmit}>
//         <FormControl fullWidth margin="normal">
//           <InputLabel id="primary-filter-label">Primary Filter</InputLabel>
//           <Select
//             labelId="primary-filter-label"
//             value={primaryFilter}
//             label="Primary Filter"
//             onChange={(e) => setPrimaryFilter(e.target.value)}
//             required
//           >
//             {primaryFilters.map(({ value, label }) => (
//               <MenuItem key={value} value={value}>
//                 {label}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         <TextField
//           label="Keyword"
//           value={keyword}
//           onChange={(e) => setKeyword(e.target.value)}
//           fullWidth
//           margin="normal"
//         />

//         {renderFilterInputs()}

//         {error && (
//           <Typography color="error" variant="body2" mt={1}>
//             {error}
//           </Typography>
//         )}

//         <Box mt={2} display="flex" justifyContent="flex-end" alignItems="center">
//           <Button
//             type="submit"
//             variant="contained"
//             disabled={loading || !primaryFilter}
//           >
//             Search
//           </Button>
//           {loading && <CircularProgress size={24} sx={{ ml: 2 }} />}
//         </Box>
//       </form>
//     </Box>
//   );
// }

